<template>
	<section class="oxigrafia inner-screen">
		<video-page :data="data"></video-page>
	</section>	
</template>

<script>
import VideoPage from './VideoPage'
import vasi from '../assets/img/tools/vasi.png';
import kalemi from '../assets/img/tools/kalemi.png';
import oxi from '../assets/img/tools/oxi.png';
import dialitiko from '../assets/img/tools/dialitiko.png';
import melani from '../assets/img/tools/melani.png';
import cloth from '../assets/img/tools/cloth.png';
import presa from '../assets/img/tools/presa.png';
import video1 from './../assets/videos/etching/etch_001.mp4';
import video2 from './../assets/videos/etching/etch_002.mp4';
import video3 from './../assets/videos/etching/etch_003.mp4';
import video4 from './../assets/videos/etching/etch_004.mp4';
import video5 from './../assets/videos/etching/etch_005.mp4';
import video6 from './../assets/videos/etching/etch_006.mp4';
import video7 from './../assets/videos/etching/etch_007.mp4';

export default {
  name: 'oxigrafia',
  components: {
    VideoPage
  },
  created: function() {
      window.document.title = "ΟΞΥΓΡΑΦΙΑ - ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ";
  },
  data () {
    return {
      data: {
      	stepcount: 7,
      	step_icons: [
      		{src: vasi},
      		{src: kalemi},
      		{src: oxi},
          {src: dialitiko},
          {src: melani},
          {src: cloth},
          {src: presa}
      	],
      	videos: [
      		{src: video1},
      		{src: video2},
      		{src: video3},
      		{src: video4},
          {src: video5},
          {src: video6},
          {src: video7},
      	],
      	description: [
      		{text: 'Η μεταλλική πλάκα (χάλκινη, τσίγκινη κ.ά.) καλύπτεται -στην επιφάνειά της- με λεπτό στρώμα ασφάλτου ή κεριού, διαλυμένου με νέφτι (βάση). '},
      		{text: 'Μόλις στεγνώσει, ο χαράκτης μεταφέρει το σχέδιο που έχει ήδη φιλοτεχνήσει στη μεταλλική πλάκα (με καρμπόν π.χ.). Κατόπιν με ειδικά εργαλεία-ατσάλινες βελόνες  χαράσσει τη σύνθεσή του.'},
      		{text: 'Έπειτα, η πλάκα βυθίζεται για λίγη ώρα σε οξύ το οποίο σιγά-σιγά ‘’τρώει’’ το μέταλλο στα μέρη  όπου υπάρχει το σχέδιο. Η υπόλοιπη πλάκα μένει ανέπαφη επειδή την είχε περάσει με την βάση (άσφαλτο κ.ά.)  που αντέχει στο οξύ. Μετά την οξείδωση, η πλάκα ξεπλένεται από το οξύ με άφθονο νερό (λαστιχένια γάντια, γυαλιά και μάσκα είναι απαραίτητα βέβαια…).'},
      		{text: 'Με ειδικό διαλυτικό καθαρίζεται η πλάκα από την άσφαλτο και το σχέδιο του χαράκτη  φαίνεται στην επιφάνεια της πλάκας, χαραγμένο πλέον από το οξύ και με τις γραμμές εσώγλυφες. '},
          {text: 'Η πλάκα μελανώνεται με το χαλκογραφικό μελάνι (που είναι πολύ πηχτό), με σκοπό αυτό να εισχωρήσει στις  γραμμές της χάραξης.'},
          {text: 'Με προσοχή το μελάνι καθαρίζεται (με εφημερίδες π.χ.) από τη μεταλλική επιφάνεια ώστε να μείνει μόνο μέσα στις γραμμές της χάραξης.'},
          {text: 'Η μελανωμένη πλάκα τοποθετείται στο χαλκογραφικό πιεστήριο με ένα φύλλο χαρτί και χοντρό ύφασμα από πάνω. Η πίεση βοηθά το σχέδιο να τυπωθεί στο χαρτί. Ο χαράκτης επαναλαμβάνει τη διαδικασία, μελάνωμα – τύπωμα, τόσες φορές όσες και τα χαρακτικά που του χρειάζονται.'}
      	]
      }
    }
  },
  mounted: function() {
      this.$emit('hideLoader')
  }
}
</script>


// WEBPACK FOOTER //
// Oxigrafia.vue?6eac333e